import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../AdvanceSearch/search.css";
import { getTopThingsToDoList } from "../../services/restapiService";
import { useNavigate } from "react-router-dom";


const AdvanceSearch = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [topThings, setTopThings] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState(null);

  const categories = [...new Set(topThings.map((item) => item.category))];

  // Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await getTopThingsToDoList(token);

        const formatted = response.data.data.map((item) => ({
          id: item.id,
          title: item.title,
          category: item.category,
        }));

        setTopThings(formatted);
      } catch (err) {
        console.error("Failed to fetch top things");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handle Google-style search input
  const handleInput = (value) => {
    setSearchText(value);

    if (value.trim() === "") {
      setSuggestions([]);
      return;
    }

    const filtered = topThings.filter(
      (item) =>
        item.title.toLowerCase().includes(value.toLowerCase()) ||
        item.category.toLowerCase().includes(value.toLowerCase())
    );

    setSuggestions(filtered.slice(0, 8));
  };

  const handleSelect = (item) => {
    setSearchText(item.title);
    setSuggestions([]);
  };

  const handleBooking = (id) => {
    console.log("Booking trip with ID:", id);
    navigate(`/trip-details/${id}`);
    // You can redirect to a booking page or open a modal
  };

  return (
    <section className="hero-search-section hidden md:block">
      <Container>
        <Row className="justify-content-center">
          <Col md={12}>
            <div className="search-card w-full max-w-6xl mx-auto mt-4 md:mt-6
    rounded-2xl p-4 md:p-6
    border border-gray-500
    bg-white/20
    backdrop-blur-xl
    shadow-xl">

              {/* Tabs */}
              <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-4">
                {categories.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`
                          px-3 sm:px-4
                          py-2
                          rounded-full
                          font-semibold
                          transition-all
                          duration-300
                          whitespace-nowrap
                          ${activeTab === tab
                        ? "bg-black text-white"
                        : "bg-black/20 text-white hover:bg-black/40"
                      }
                    `}
                  >
                    {tab}
                  </button>
                ))}

                {categories.length === 0 && (
                  <span className="text-white opacity-60">
                    No categories found
                  </span>
                )}
              </div>

              {/* Inputs */}
              <div className="grid grid-cols-1 gap-4">

                {/* From */}
                <div className="relative rounded-xl bg-black/20 backdrop-blur-md p-4 shadow-lg">
                  <label className="block font-semibold text-gray-200 mb-3">
                    Search Destination
                  </label>

                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => handleInput(e.target.value)}
                    className="
                      w-full
                      h-12
                      px-4
                      text-white
                      placeholder-gray-300
                      bg-transparent
                      border
                      border-gray-500
                      rounded-xl
                      focus:outline-none
                      focus:ring-2
                      focus:ring-green-500
                      "
                  />

                  {/* GOOGLE STYLE SUGGESTION DROPDOWN */}
                  {suggestions.length > 0 && (
                    <ul
                      className="
absolute
left-0
right-0
top-full
mt-2
bg-white
rounded-xl
shadow-2xl
overflow-hidden
max-h-80
overflow-y-auto
z-50
"
                    >
                      {suggestions.map((item) => (
                        <li
                          key={item.id}
                          onClick={() => {
                            handleSelect(item);
                            handleBooking(item.id);
                          }}
                          className="
                                      px-4
                                      py-3
                                      bg-white
                                      hover:bg-gray-100
                                      cursor-pointer
                                      transition
                                      text-black
                                      "
                        >
                          <div className="font-semibold text-black">
                            {item.title}
                          </div>
                          <div className=" text-black">
                            {item.category}
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* Journey Date */}
                {/* <div className="p-3 rounded-lg backdrop-blur-md border border-gray-500 shadow bg-black/20">
                  <label className="text-xs text-gray-300 font-bold mb-1 block">
                    Journey Date
                  </label>
                  <div className="font-semibold text-white text-base mt-1">
                    19/09/2025
                  </div>
                  <div className="text-xs text-gray-400 mt-1">Friday</div>
                </div> */}
              </div>

              {/* Search Button */}
              <div className="flex justify-center mt-6">
                <button className="
w-full
sm:w-auto
min-w-[220px]
h-12
px-8
rounded-xl
font-semibold
sm:text-base
text-white
bg-emerald-600
hover:bg-emerald-700
transition
shadow-lg
">
                  Search Destinations
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AdvanceSearch;
